import { render } from "./employee-salaries.vue?vue&type=template&id=249b5e54&scoped=true"
import script from "./employee-salaries.vue?vue&type=script&lang=js"
export * from "./employee-salaries.vue?vue&type=script&lang=js"

import "./employee-salaries.vue?vue&type=style&index=0&id=249b5e54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249b5e54"]])

export default __exports__